<template>
  <div id="app" v-if="!isLoading">
    <div v-if="shouldRenderLayout">
      <HeaderBar/>
      <div class="main-container d-lg-flex">
        <SideMenu/>
        <router-view/>
      </div>
    </div>
    <div v-else>
      <router-view/>
    </div>
  </div>
  <loading-view v-else></loading-view>
</template>

<script>
// import moment from "moment-timezone";
import HeaderBar from "@/views/components/HeaderBar";
import LoadingView from "@/views/components/LoadingView";
import api from "@/lib/callAPI";
import SideMenu from "@/views/components/SideMenu.vue";
import ReConnectPageModal from "@/views/components/modals/ReConnectPageModal";
import PermissionModal from "@/views/components/modals/PermissionModal";
import StartSubscriptionModal from "@/views/components/modals/StartSubscriptionModal";
import NotiAccountModal from "@/views/components/modals/NotiAccountModal";
import NotiAuthModal from "@/views/components/modals/NotiAuthModal";
// import NotificationModal from "@/views/components/modals/NotificationModal.vue";
import util from "@/lib/util";

export default {
  name: 'App',
  components: {
    HeaderBar,
    SideMenu,
    LoadingView,
  },
  data() {
    return {
      isLoading: true,
      code : '',
    }
  },

  beforeMount() {
    if (this.globalData.token) {
      this.isLoading = false;
    } else {
      setTimeout(() => {
        this.isLoading = false
      }, 5000);
    }
  },

  mounted() {
    this.socket.on('dataStockSocketEmit', async (data) => {
      const method = data.data?.method;
      switch (method) {
        case 'gitInitDataStock':
          if (data.code === this.code && data.data?.data?.company_id) {
            return this.globalData.local_data = data.data.data;
          } else return
        case 'updateReview':
          return this.$root.$emit('updateReview_socket', data)
        case 'getOrderByCustomer':
          return this.$root.$emit('getOrderByCustomer_socket', data)
        case 'getOrderById':
          return this.$root.$emit('getOrderById_socket', data)
        case 'getProductSWStock':
          return this.$root.$emit('getProductSWStock_socket', data)
        case 'getOrderReverse':
          return this.$root.$emit('getOrderReverse_socket', data)
        default :
          break
      }
    });
    this.socket.on('accountExpired', async (data) => {
      const accounts =  data.accounts
      if(accounts){
        this.globalData.initData.pages =  accounts
      }
      this.$modal.show(ReConnectPageModal, null, {width: '40%'})
    });
    this.socket.on('updateCompanyInitData', async(data)  => {
      this.globalData.initData = data.initData;
      if (this.globalData.logged_in_user.type !== 'ADMIN') {
        this.globalData.initData.pages = this.globalData.initData.pages.filter(p => p.employees.includes('all') || p.employees.some(e => e === this.globalData.logged_in_user.username));
      }
      this.globalData.initData.pages =  this.fixDuplicateNames(this.globalData.initData.pages);
    });
  },

  async beforeCreate() {
    let url = new URL(window.location.href);
    let isAgency = url.href.includes("/c/");
    let verify_result = isAgency ? await api.get(`/auth/personalAgency?companyCode=${url.pathname.split('/')[2]}`) : await api.get('/auth/personal');
    if (verify_result.success) {
      this.globalData.token = verify_result.data;
      this.globalData.logged_in_user = this.$jwt.decode(verify_result.data);
      this.checkAdmin();
      this.globalData.cCode = isAgency ? '/c/' + this.globalData.logged_in_user.company.code : '';
      document.title = 'Salework Chat - ' + this.globalData.logged_in_user.company.alias.toUpperCase();
      this.online();
      if(this.globalData.logged_in_user.paymentType === 'TRIAL' && this.globalData.logged_in_user.plan === 'NOT_USED'){
        this.isLoading = false
        return this.$modal.show(StartSubscriptionModal,null, {width: '500px', clickToClose: false, draggable: false});
      }
      // if (window.localStorage.getItem('hide_banner_survey') !== 'hide') {
      //   this.$modal.show(NotificationModal,{},{width: '900px', clickToClose: false, draggable: false});
      // }
      await api.get('/api/settings/getCompanyConfigurations').then(result => {
        if (result.success) {
          this.globalData.company_configurations = result.data;
          const index = this.globalData.company_configurations.employees?.findIndex((employee) => employee.username === this.globalData.logged_in_user.username);
          if (index === -1 && this.globalData.logged_in_user.type !== "ADMIN") {
            return this.$modal.show(PermissionModal, {type: 'redirect'}, {clickToClose: false, draggable: false});
          }
          // const currentTime = moment();
          // const startTime = moment(this.globalData.logged_in_user.createdDate);
          // if(moment.duration(currentTime.diff(startTime)).asMinutes() <= 15){
          //   return this.$modal.show(ActivateTrialModal,null,{width: '65%'} );
          // }
        }else {
          this.isLoading = false
        }
      });
      await api.get('/api/settings/getInitData').then(result => {
        if (result.success) {
          this.globalData.initData = result.data;
          if (this.globalData.logged_in_user.tiktokShopLimit || this.globalData.logged_in_user.tiktokShopLimit === 0  ) {
            if (this.globalData.initData.pages.filter(page => page._id.channel === this.globalData.channel.TIKTOK.name).length > this.globalData.logged_in_user.tiktokShopLimit) {
              this.$modal.show(NotiAccountModal, {type:"limit_account"}, {width: '480px', clickToClose: false, draggable: false})
            }
            if (this.globalData.initData.pages.length > this.globalData.logged_in_user.shopLimit) {
              this.$modal.show(NotiAccountModal, {type:"limit_account"}, {width: '480px', clickToClose: false, draggable: false})
            }
          } else {
            if (this.globalData.initData.pages.length > this.globalData.logged_in_user.shopLimit) {
              this.$modal.show(NotiAccountModal, {type:"limit_account"}, {width: '480px', clickToClose: false, draggable: false})
            }
          }
          if (this.globalData.logged_in_user.type !== 'ADMIN') {
            this.globalData.initData.pages = this.globalData.initData.pages.filter(p => p.employees.includes('all') || p.employees.some(e => e === this.globalData.logged_in_user.username));
          }
          this.isLoading = false
          if (this.globalData.initData.pages.filter(p => p.expired === true).length > 0) {
            this.$modal.show(ReConnectPageModal, null, {width: '40%',  draggable: false})
          }
          this.globalData.initData.pages =  this.fixDuplicateNames(this.globalData.initData.pages);

          this.getAIConfig();
        }
      });
    } else {
      if ( ![ "expired"].includes(verify_result.message) ){
        this.$modal.show(NotiAuthModal, {type:"err_auth"}, {width: '480px', clickToClose: false, draggable: false});
      }else {
        this.$modal.show(NotiAccountModal, {type:verify_result.message}, {width: '480px', clickToClose: false, draggable: false})
      }
    }
    this.getInitDataStock();
  },
  computed: {
    shouldRenderLayout() {
      const currentURL = window.location.pathname;
      if (currentURL === '/iframe') {
        return false;
      } else {
        return true;
      }
    },
  },
  created() {
    this.$root.$on('showToast', (variant, message) => {
      this.bvToast(variant, message)
    });
  },
  methods: {
    getInitDataStock() {
      this.code = util.generateRandomString(32);
      api.get('/api/settings/getStockData', {code: this.code})
    },

    async getAIConfig() {
      const account_ids =  this.globalData.initData.pages.map(p => p._id.account_id);
      const all_ai_config = await api.post('/api/settings/getAIConfigs', {account_ids: account_ids});
      if(all_ai_config.success){
        this.globalData.ai_configurations = all_ai_config.data;
      }
    },
    bvToast(variant, message) {
      this.$bvToast.toast(message, {
        variant: variant,
        solid: true,
        noCloseButton: true
      });
    },
    checkAdmin() {
      if (this.globalData.logged_in_user.type === 'ADMIN' || this.globalData.logged_in_user.permissions?.filter(p => p.code === 'CHAT_MANAGE').length > 0) {
        this.globalData.isAdmin = true;
      }
    },
    fixDuplicateNames(pages) {
      const nameCount = {};
      pages.forEach(page => {
        if (!nameCount[page.name]) {
          nameCount[page.name] = 1;
        } else {
          const newName = `${page.name} - ${page._id.account_id}`;
          page.name = newName;
          nameCount[page.name]++;
        }
      });
      return pages
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

